import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['DELETE', 'LOAD_RELATIONSHIP', 'UPDATE_RELATIONSHIP']);
